/* eslint-disable no-debugger */
import { Navigate } from "react-router-dom";
import { decrypt } from "./crypto";
import { isObject } from "formik";
import { showToast } from "../store/toastSlice";
let isTokenExpiredToastShown = false;
export const transformResponseHandler = async (resp, meta, alert) => {
 

  if (!isObject(resp.data) && resp.data) {
    let decrptedData = decrypt(resp.data);
    resp.data = JSON.parse(decrptedData);
  }
  // console.log(resp.data,"resp.data");
  let notificationType = "";

  if (
    alert &&
    (resp?.message || resp.data?.message) &&
    (meta.response.status !== 555 &&
      resp.status !== 555 &&
      resp?.data?.status !== 555)
  ) {
    notificationType =
      meta.response.status >= 400 ||
      resp?.status >= 400 ||
      resp?.data?.status >= 400
        ? "error"
        : "success";
    if (!isTokenExpiredToastShown && notificationType === "error") {
      isTokenExpiredToastShown = true;
      // await messageNotification(
      //   resp?.message || resp?.data?.message,
      //   notificationType
      // );
      const { store } = await import("../store/store");
    store.dispatch(
      showToast({
        message: resp?.message || resp?.data?.message,
        type: notificationType,
      })
    );
      // Reset the flag after a delay
      setTimeout(() => {
        isTokenExpiredToastShown = false;
      }, 3100); // 5 seconds delay to prevent duplicate toasts
    } else if (notificationType === "success") {
      // await messageNotification(
      //   resp?.message || resp?.data?.message,
      //   notificationType
      // );
      const { store } = await import("../store/store");
    store.dispatch(
      showToast({
        message: resp?.message || resp?.data?.message,
        type: notificationType,
      })
    );
    }
  }

  if (resp?.data?.token) {
    const { store } = await import("../store/store");
    const { setUserToken } = await import("../store/slice");
    store.dispatch(setUserToken({ token: resp?.data?.token }));
  }

  if (
    meta.response.status == 555 ||
    resp.status == 555 ||
    resp?.data?.status == 555
  ) {
    const { store } = await import("../store/store");
    const { removeUserToken } = await import("../store/slice");
    store.dispatch(removeUserToken({}));
    <Navigate to="/login" />;
  }

  let transformedResp = {
    success: resp.success,
    data: resp?.data,
    total: resp.total,
    extra_meta: resp.extra_meta,
    message: resp?.message || resp?.data?.message,
    notificationType,
  };

  if (resp.token) {
    transformedResp.token = resp.token;
    // transformedResp.refreshToken = resp.refreshToken;
  }

  return transformedResp;
};
